import azureAuth from '@/screens/login/azure/azureAuth';
import  {sanitizeDomain}  from '../common/sanitizeUtils';

export default {
  getStoredCredentials() {
    let origin = window.location.origin;
    const domainKey = sanitizeDomain(origin);
    const token = getCookie(`${domainKey}-token`);
    const refreshToken = getCookie(`${domainKey}-refreshToken`);
    if (token && localStorage.getItem('user')) {
      let { userName, employeeNr, email, firstName, lastName, groups } = JSON.parse(localStorage.getItem('user'));
      //let token = localStorage.getItem('token');
      let expiresInSeconds = localStorage.getItem('expiresInSeconds');
      //let refreshToken = localStorage.getItem('refreshToken');
      let tokenExpiry = localStorage.getItem('tokenExpiry');
      let rememberMe = localStorage.getItem('rememberMe');

      if (token && refreshToken) {
        return {
          responseCode: 'isAuthenticated',
          token,
          refreshToken,
          expiresInSeconds,
          userName,
          employeeNr,
          email,
          firstName,
          lastName,
          groups,
          tokenExpiry,
          rememberMe,
        };
      }
    }
    return { responseCode: 'loginRequired' };
  },
  /**
   * @typedef AuthenticationResponse
   * @type {object}
   * @property {string} responseCode - isAuthenticated | loginRequired | externalSignInStarted
   * @property {string} token - the JWT app token (only when authenticated)
   * @property {string} refreshToken - the JWT refreshToken token (only when authenticated)
   * @property {number} expiresInSeconds - expiresInSeconds (only when authenticated)
   * @property {string} userName - user name (only when authenticated)
   * @property {string} employeeNr - employeeNr (only when authenticated)
   * @property {string} firstName - firstName (only when authenticated)
   * @property {string} lastName - lastName (only when authenticated)
   * @property {Array} groups - lastName (only when authenticated)
   * @property {boolean} rememberMe - if the login should be remembered  (only when authenticated)
   */
  /**
   * Try to authenticate the user, be it by a stored login or if configured
   * a cloud login method.
   * The response contains the responseCode attribute which decides what needs to
   * be done after this method: The code is one of isAuthenticated | loginRequired | externalSignInStarted
   * @param {*} cloudAuthProviderConfig - the cloud auth provider config
   * @param {*} rememberLogin - rememberLogin boolean
   * @returns {AuthenticationResponse} authenticationResponse
   */
  async tryAuthentication(cloudAuthProviderConfig, rememberLogin, autoLogin = true) {
    let credentials;
    let azureAccessToken = localStorage.getItem('azure.access-token');
    if (cloudAuthProviderConfig && (autoLogin || azureAccessToken)) {
      try {
        switch (cloudAuthProviderConfig.type) {
          case 'azure':
            credentials = await azureAuth.authenticateUser(cloudAuthProviderConfig);
            credentials.responseCode = 'isAuthenticated';
            break;
        }
        if (!credentials) {
          credentials = { responseCode: 'loginRequired' };
        }
      } catch (err) {
        console.warn('cloudAuth failed, but login initiated', err);
        credentials = { responseCode: 'externalSignInStarted' };
      }
    } else if (rememberLogin === true) {
      // Check if login can be skipped because it is stored in local storage
      credentials = this.getStoredCredentials();
    }

    return credentials;
  },
};

export function getCookie(cookieName) {
  var name = cookieName + '=';
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export function parseJwt(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map((c) => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join('')
  );

  return JSON.parse(jsonPayload);
}
